<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-moralismScreen__moralismscreenrule">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('moralismScreen:moralismscreenrule:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <template>
          <p>菜单配置：</p>
        </template>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="isClassEvaluate" label="是否显示班级评价" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isClassEvaluate === moralismScreen.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isClassEvaluate === moralismScreen.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isZzjz" label="是否显示争章集赞" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isZzjz === moralismScreen.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isZzjz === moralismScreen.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isHljzz" label="是否显示红领巾争章" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isHljzz === moralismScreen.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isHljzz === moralismScreen.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isExposure" label="是否显示点赞曝光" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isExposure === moralismScreen.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isExposure === moralismScreen.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isDataStatistics" label="是否显示数据统计" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isDataStatistics === moralismScreen.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isDataStatistics === moralismScreen.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('moralismScreen:moralismscreenrule:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('moralismScreen:moralismscreenrule:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
<!--      <el-pagination-->
<!--        :current-page="page"-->
<!--        :page-sizes="[10, 20, 50, 100]"-->
<!--        :page-size="limit"-->
<!--        :total="total"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        @size-change="pageSizeChangeHandle"-->
<!--        @current-change="pageCurrentChangeHandle">-->
<!--      </el-pagination>-->
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>

    <div class="mod-MoralismScreenBoardRule__moralismscreenboardrule">
      <el-form :inline="true" :model="from" @keyup.enter.native="getBoardDataList()">
        <el-form-item>
          <el-button @click="getBoardDataList()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('MoralismScreenBoardRule:moralismscreenboardrule:save')" type="primary" @click="boardAddOrUpdateHandle()">{{ $t('add') }}默认规则</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('MoralismScreenBoardRule:moralismscreenboardrule:save')" type="primary" @click="boardUpdateHandle()">{{ $t('update') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('MoralismScreenBoardRule:moralismscreenboardrule:delete')" type="primary"  @click="deleteBoardHandle()">{{ $t('delete') }}全部规则</el-button>
        </el-form-item>

      </el-form>
      数据看板规则：
      <el-table v-loading="boardDataListLoading" :data="dataBoardList" border  style="width: 100%;" @selection-change="handleSelectionChange">
<!--        <el-table-column type="selection" header-align="center" align="center" width="50" ></el-table-column>-->
        <!--        0:点赞曝光 1:班级评价趋势2:班级评价维度3:学生出勤4:学生评价趋势5:学生评价维度-->
        <el-table-column prop="boardType" label="学生评价维度" header-align="center" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.boardType === 0" size="small" type="success">点赞曝光</p>
            <p v-if="scope.row.boardType === 1" size="small" type="success">班级评价趋势</p>
            <p v-if="scope.row.boardType === 2" size="small" type="success">班级评价维度</p>
            <p v-if="scope.row.boardType === 3" size="small" type="success">学生出勤</p>
            <p v-if="scope.row.boardType === 4" size="small" type="success">学生评价趋势</p>
            <p v-if="scope.row.boardType === 5" size="small" type="success">学生评价维度</p>
            <p v-if="scope.row.boardType === 6" size="small" type="success">点赞曝光</p>
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否显示" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isShow === moralismScreen.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isShow === moralismScreen.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
<!--        <el-table-column prop="schoolId" label="学校id" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="weight" label="排序" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
<!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
<!--          <template slot-scope="scope">-->
<!--&lt;!&ndash;            <el-button v-if="$hasPermission('MoralismScreenBoardRule:moralismscreenboardrule:update')" type="text" size="small" @click="boardUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>&ndash;&gt;-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
<!--      <el-pagination-->
<!--              :current-page="page"-->
<!--              :page-sizes="[10, 20, 50, 100]"-->
<!--              :page-size="limit"-->
<!--              :total="total"-->
<!--              layout="total, sizes, prev, pager, next, jumper"-->
<!--              @size-change="pageSizeChangeHandle"-->
<!--              @current-change="pageCurrentChangeHandle">-->
<!--      </el-pagination>-->
      <!-- 弹窗, 新增 / 修改 -->
      <board-add-or-update v-if="boardUpdateHandleVisible" ref="boardAddOrUpdate" @refreshDataList="getBoardDataList"></board-add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { moralismScreen } from '@/constant'
import AddOrUpdate from './moralismscreenrule-add-or-update'
import BoardAddOrUpdate from './moralismscreenboardrule-add-or-update'
import Template from '../devtools/template'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/moralismScreenRule/moralismscreenrule/page',
        getDataListIsPage: true,
        exportURL: '/moralismScreenRule/moralismscreenrule/export',
        deleteURL: '/moralismScreenRule/moralismscreenrule',
        deleteIsBatch: true
      },
      dataForm: {},
      from: {},
      dataBoardList: [],
      boardUpdateHandleVisible: false,
      boardDataListLoading: false,
      moralismScreen
    }
  },
  components: {
    Template,
    AddOrUpdate,
    BoardAddOrUpdate
  },
  watch: {},
  mounted () {
    this.getBoardDataList()
  },
  methods: {
    handleSelectionChange (selection) {
      console.log(selection)
    },
    boardUpdateHandle () {
      this.boardUpdateHandleVisible = true
      this.$nextTick(() => {
        this.$refs.boardAddOrUpdate.form.dataBoardList = this.dataBoardList
        this.$refs.boardAddOrUpdate.init()
      })
    },
    boardAddOrUpdateHandle () {
      this.boardDataListLoading = true
      this.$http.post('/MoralismScreenBoardRule/moralismscreenboardrule/defaultRule').then(({ data: res }) => {
        this.boardDataListLoading = false
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.from = {
          ...this.from,
          ...res.data
        }
        this.getBoardDataList()
      }).catch(() => {

      })
    },
    deleteBoardHandle () {
      this.boardDataListLoading = true
      this.$http.post('/MoralismScreenBoardRule/moralismscreenboardrule/delete').then(({ data: res }) => {
        this.boardDataListLoading = false
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.dataBoardList = res.data.list
        console.log('-----')
        this.getBoardDataList()
        console.log(this.dataBoardList)
      })
    },

    getBoardDataList () {
      this.boardDataListLoading = true
      this.$http.get('/MoralismScreenBoardRule/moralismscreenboardrule/page').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataBoardList = res.data.list
        this.boardDataListLoading = false
        console.log(this.dataBoardList)
      })
    }
  }
}
</script>
